import React from 'react'

const truncate = (text, max) => {
    if (!text) return ''
    const clean = text.replace(/\r?\n/g, ' ').replace(/[✔•]/g, '').trim()
    return clean.length > max ? `${clean.slice(0, max).trim()}…` : clean
}

const courseIcon = (title = '') => {
    if (/\d+\s*-?\s*days?/i.test(title)) return 'bi-calendar2-week-fill'
    if (/test day/i.test(title)) return 'bi-patch-check-fill'
    return 'bi-car-front-fill'
}

const CourseSelection = ({ course_types = [], selectedCource, onSelectCourse, errors, returningInstructor }) => {

    return (
        <div>
            <div>
                <h2 className='pt-3 pb-2 fs-2 fw-semibold'>Select Your Course</h2>
                <p>Choose the lesson or course package you'd like to book.</p>
            </div>

            {
                returningInstructor &&
                <div className='booking-returning-banner'>
                    <i className='bi bi-person-check-fill'></i>
                    Welcome back! We'll try to book you with <b>{returningInstructor.name}</b> again, since that's who you had last time.
                </div>
            }

            {
                errors?.selected_course &&
                <div className='text-danger alert mb-0 p-0 badge text-start mt-2'>{errors?.selected_course}</div>
            }

            <div className='booking-course-list mt-4'>
                {
                    course_types.length === 0 && (
                        <div className='input-white-box d-block px-3'>No Course Available</div>
                    )
                }
                {
                    course_types.map((course) => {
                        const isSelected = selectedCource?.id === course.id
                        return (
                            <div
                                key={course.id}
                                className={`booking-course-card${isSelected ? ' selected' : ''}`}
                            >
                                <div className='booking-course-card-icon'>
                                    <i className={`bi ${courseIcon(course.title)}`}></i>
                                </div>
                                <div className='booking-course-card-body'>
                                    <div className='booking-course-card-top'>
                                        <h3>{course.title}</h3>
                                        <span className='booking-course-card-price'>£{course.price}</span>
                                    </div>
                                    <span className='booking-course-card-transmission'>{course.cartype} Transmission</span>
                                    <p>{truncate(course.description, 130)}</p>
                                </div>
                                <button
                                    type='button'
                                    className={`booking-course-card-btn${isSelected ? ' selected' : ''}`}
                                    onClick={() => onSelectCourse(course)}
                                >
                                    {isSelected ? 'Selected' : 'Select Course'}
                                </button>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default CourseSelection
